import { useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { tools } from "../data/tools";
import { SEO } from "../components/SEO";
import { toolMeta } from "../seo/meta";
import { ToolContent, getToolContent } from "../components/ToolContent";
import {
  ColorPaletteGenerator,
  JsonFormatter,
  JsonToToon,
  PasswordGenerator,
  QRCodeGenerator,
  RobotsTxtGenerator,
  RedirectsTester,
  CompoundCalculator,
  ColorConverter,
  ColorInverter,
  RegexTester,
  TimeZoneConverter,
  WordCounter,
  LoremIpsumGenerator,
  Base64Encoder,
  UUIDGenerator,
  BusinessNameGenerator,
  FreeLogoCreator,
  SitemapGenerator,
  HexagonDragAndDrop,
  TextCaseConverter,
  ImageToPdf,
} from "./tools";

const toolComponents: Record<string, React.ComponentType> = {
  "password-generator": PasswordGenerator,
  "json-formatter": JsonFormatter,
  "json-to-toon": JsonToToon,
  "qr-code-generator": QRCodeGenerator,
  "color-palette-generator": ColorPaletteGenerator,
  "robots-txt-generator": RobotsTxtGenerator,
  "redirects-tester": RedirectsTester,
  "compound-calculator": CompoundCalculator,
  "color-converter": ColorConverter,
  "color-inverter": ColorInverter,
  "regex-tester": RegexTester,
  "time-zone-converter": TimeZoneConverter,
  "word-counter": WordCounter,
  "lorem-ipsum-generator": LoremIpsumGenerator,
  "base64-encoder": Base64Encoder,
  "uuid-generator": UUIDGenerator,
  "business-name-generator": BusinessNameGenerator,
  "free-logo-creator": FreeLogoCreator,
  "sitemap-generator": SitemapGenerator,
  "hexagon-drag-and-drop": HexagonDragAndDrop,
  "text-case-converter": TextCaseConverter,
  "image-to-pdf": ImageToPdf,
};

export function ToolPage() {
  const { t, i18n } = useTranslation();
  const { toolSlug } = useParams({ from: "/tools/$toolSlug" });
  const tool = tools.find((item) => item.slug === toolSlug);

  if (!tool) {
    return (
      <main className="content tool-page">
        <h1>{t("toolPage.notFoundTitle")}</h1>
        <p>{t("toolPage.notFoundSubtitle")}</p>
      </main>
    );
  }

  const toolName = t(`${tool.i18nKey}.name`);
  const toolDescription = t(`${tool.i18nKey}.description`);
  const ToolComponent = toolComponents[tool.slug];

  return (
    <>
      <SEO
        {...toolMeta(
          tool.slug,
          toolName,
          toolDescription,
          getToolContent(tool.slug, i18n.language)?.faq,
        )}
      />
      <main className="content tool-page">
        <div className="tool-hero">
          <div className="tool-icon large">
            <tool.Icon className="tool-icon-svg" aria-hidden="true" />
          </div>
          <h1>{t(`${tool.i18nKey}.name`)}</h1>
          <p>{t(`${tool.i18nKey}.description`)}</p>
        </div>
        {ToolComponent ? (
          <ToolComponent />
        ) : (
          <div className="coming-soon">{t("toolPage.comingSoon")}</div>
        )}
        <ToolContent slug={tool.slug} name={toolName} />
      </main>
    </>
  );
}
